var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#FCEAE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.967 37L79.3613 60.4741L85.206 46.6247L110.967 37Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0039 37L69.3557 60.6965L63.7968 46.6247L38.0039 37Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5954 91.413L91.1777 104.309L109.188 109.265L114.366 91.6988L99.5954 91.413Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 91.6988L39.8138 109.265L57.8244 104.309L49.4068 91.413L34.668 91.6988Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8098 69.6223L51.791 77.2141L69.6745 78.0082L69.0392 58.7905L56.8098 69.6223Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1625 69.6223L79.7743 58.5682L79.3613 78.0082L97.2131 77.2141L92.1625 69.6223Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 104.309L68.5607 99.0682L59.2854 91.8258L57.8242 104.309Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4102 99.0682L91.1784 104.309L89.6855 91.8258L80.4102 99.0682Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1764 104.309L80.4082 99.0682L81.2659 106.088L81.1706 109.042L91.1764 104.309Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 104.309L67.8301 109.042L67.7666 106.088L68.5607 99.0682L57.8242 104.309Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9889 87.1882L59.0312 84.5517L65.3524 81.6611L67.9889 87.1882Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9785 87.1882L83.615 81.6611L89.9679 84.5517L80.9785 87.1882Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8219 104.309L59.3466 91.413L49.4043 91.6988L57.8219 104.309Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6484 91.413L91.1731 104.309L99.5908 91.6988L89.6484 91.413Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2111 77.2141L79.3594 78.0082L81.0111 87.1882L83.6476 81.6612L90.0005 84.5518L97.2111 77.2141Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0275 84.5518L65.3804 81.6612L67.9852 87.1882L69.6687 78.0082L51.7852 77.2141L59.0275 84.5518Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7891 77.2141L59.2855 91.8259L59.0314 84.5518L51.7891 77.2141Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0012 84.5518L89.6836 91.8259L97.2118 77.2141L90.0012 84.5518Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6718 78.0083L67.9883 87.1883L70.0847 98.0201L70.5612 83.7577L69.6718 78.0083Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3596 78.0083L78.502 83.7259L78.8831 98.0201L81.0114 87.1883L79.3596 78.0083Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.013 87.1882L78.8848 98.02L80.4095 99.0682L89.6848 91.8259L90.0024 84.5518L81.013 87.1882Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0312 84.5518L59.2854 91.8259L68.5607 99.0682L70.0854 98.02L67.9889 87.1882L59.0312 84.5518Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1713 109.042L81.2666 106.088L80.4724 105.389H68.4972L67.7666 106.088L67.8301 109.042L57.8242 104.309L61.3183 107.168L68.4019 112.092H80.5677L87.683 107.168L91.1771 104.309L81.1713 109.042Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.408 99.0681L78.8833 98.0199H70.0844L68.5597 99.0681L67.7656 106.088L68.4962 105.389H80.4715L81.2656 106.088L80.408 99.0681Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 61.9988L115 49.0388L110.966 37L80.4082 59.68L92.1611 69.6223L108.774 74.4823L112.459 70.1941L110.871 69.0506L113.412 66.7318L111.442 65.207L113.983 63.2694L112.3 61.9988Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49.0388L36.7 61.9988L34.9847 63.2694L37.5259 65.207L35.5882 66.7318L38.1294 69.0506L36.5412 70.1941L40.1941 74.4823L56.807 69.6223L68.56 59.68L38.0024 37L34 49.0388Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.772 74.4823L92.1593 69.6223L97.2099 77.2141L89.6816 91.8258L99.5922 91.6988H114.363L108.772 74.4823Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.808 69.6223L40.195 74.4823L34.668 91.6988H49.4068L59.2856 91.8258L51.7891 77.2141L56.808 69.6223Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3596 78.0083L80.4079 59.68L85.2361 46.6248H63.7949L68.5596 59.68L69.6714 78.0083L70.0526 83.7894L70.0843 98.02H78.8832L78.9467 83.7894L79.3596 78.0083Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWallet);
export default __webpack_public_path__ + "static/media/browser-wallet.e3ee4ed2f7b6fcc32f00f5ba16a15d0d.svg";
export { ForwardRef as ReactComponent };